import { z } from 'zod';

export const SearchString = z.string().regex(/(^\?.+)?/);

export type SearchString = z.infer<typeof SearchString>;
